import React from 'react';
import classNames from 'classnames';
import { Typography } from '../../../foundations/typography';
import { Warning } from '../../../foundations/icons';
import styles from './ConflictCard.module.scss';
function isOfVariantType(v) {
    return ['light', 'simple', 'rich'].includes(v);
}
export var ConflictCard = function (_a) {
    var message = _a.message, _b = _a.variant, variant = _b === void 0 ? 'simple' : _b, _c = _a.textOnly, textOnly = _c === void 0 ? false : _c, className = _a.className, children = _a.children;
    if (!message && !children)
        return null;
    var variantClass = isOfVariantType(variant) ? styles[variant] : styles.simple;
    var classes = classNames(styles.conflictCard, variantClass, className);
    return (React.createElement("section", { className: classes, "data-testid": "conflict-card" },
        variant === 'rich' && !textOnly && (React.createElement(Warning, { "data-testid": "conflict-icon", className: styles.icon })),
        React.createElement("div", { className: styles.content, "data-testid": "conflict-content" },
            message && (React.createElement(Typography, { element: "span", styleAs: "paragraphHeading" }, message)),
            children)));
};
//# sourceMappingURL=ConflictCard.js.map